export default function isHighContrastTheme(theme) {
    return Boolean(theme.appearance && theme.appearance.highContrast);
}
